export default "__VITE_ASSET__ebf44f19__"